import React from "react"

import "./index.scss"

const DashboardContent = ({ children }) => {
  return <main className="content">{children}</main>
}

export default DashboardContent
